import React from 'react';
export function EmotionalTransition() {
  return <section className="bg-violeta-profundo text-crema py-20 sm:py-24 px-5" data-id="element-83" data-mp="2x91ejtqeig31">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-84" data-mp="pg47vkns7cnr">
        <p className="text-lg sm:text-xl leading-relaxed text-crema/85" data-id="element-85" data-mp="kodpqsilrkls">
          No es pereza y no es falta de voluntad. Es lo primero que uno piensa, y es lo primero que
          hay que descartar.
        </p>
        <p className="font-serif text-2xl sm:text-4xl font-bold text-white leading-snug" data-id="element-86" data-mp="bp8txtyfe5db">
          Escribir es un movimiento, y un movimiento se entrena. Nadie le enseñó cómo.
        </p>
        <p className="text-lg sm:text-xl leading-relaxed text-crema/85" data-id="element-87" data-mp="1p88a1d33d5y">
          Por eso repetir planas no alcanza: se repite el error, no se corrige.
        </p>
      </div>
    </section>;
}